<script>
  import SinglePublish from "../Stores/singlePublishStore"
  /**
   * @type {Object} table list data
   */
  export let json
</script>

<button on:click class="mx-auto border-2 {$SinglePublish.documentTemplateId == json.id ? 'border-blue-400' : 'border-transparent bg-[#f7f7f7] '} mt-3 flex h-full w-full flex-col gap-3 rounded-md px-6 py-3 hover:shadow-md dark:border-2 dark:border-transparent dark:bg-bodyblack dark:hover:border-green-500">
  <div class="flex flex-col justify-between gap-3 truncate mobile:flex-row sm:items-center sm:gap-6">
    <div class="space-y-1.5 truncate">
      <p class="truncate text-start text-sm font-semibold text-blue-500 sm:text-lg">{json.name}</p>
      <p class="truncate text-start font-mono text-xs font-medium text-gray-800 dark:text-gray-200 sm:text-base">{json.id}</p>
    </div>
    <div class="flex select-none items-center justify-start truncate mobile:justify-end">
      <p class="select-none truncate font-mono text-xs text-gray-200 dark:text-gray-500 sm:text-base">
        <i class="fa-solid fa-calendar-days" />
        &nbsp;{new Date(json.modified || json.created).toString().slice(0, 24)}
      </p>
    </div>
  </div>
</button>

<style>
  ::-webkit-scrollbar-thumb {
    background: #f7f7f7;
    border-radius: 20px;
  }
  ::-webkit-scrollbar {
    height: 4px;
  }
</style>
